import Tooltip from "./Tooltip";
import { COLORS, POSITIONS, SIZES } from "./utilities";

export { COLORS, POSITIONS, SIZES };
export default Tooltip;
